<div class="flex-auto gt-xs:pr-3 w-full min-w-0 mb-2">
  <label class="block text-ts-input-label-size text-ts-input-label font-ts-input-label-weight leading-ts-input-label">
    <span class="text-ellipsis overflow-hidden pointer-events-auto" [matTooltip]="fieldDef.label" tooltipIfEllipsis>
      {{ fieldDef.label }}
    </span>
  </label>
  <div
    class="ts-select-wrapper"
    [ngClass]="{ disabled: isDisabled }"
    TsFieldStyling
    [fieldBackgroundColor]="fieldStyling().color"
    [fieldBold]="fieldStyling().is_bold"
    [targetStylingClass]="tsSelectTargetStylingClass"
    style="max-width: 100%"
  >
    <ts-select
      [testId]="'form-field-' + fieldDef.name"
      [ngModel]="value"
      (ngModelChange)="onSelectionChange($event)"
      [name]="fieldDef.name"
      [items]="options"
      itemKey="id"
      itemLabel="value"
      [disabled]="isDisabled"
      [uiOptions]="{
        placeholder: 'Select...',
        searchPlaceholder: 'Search...',
      }"
    />
  </div>
</div>
